module.exports = __webpack_public_path__ + "images/data_1.png";